import { useState } from 'react';

import { ApplicationModule } from 'shared/modules';

import { useReaction } from './useReaction';

export const useUser = () => {
    const [user, setUser] = useState(ApplicationModule.user);

    useReaction(
        () => {
            setUser(ApplicationModule.user);
        },
        () => [ApplicationModule.user, ApplicationModule.user.id]
    );

    return user;
};
